import { inject } from "@angular/core";
import type { NiceAsyncTypeaheadSearchResult } from "@recursyve/ngx-material-components/typeahead";
import { NiceAsyncTypeaheadResourceProvider } from "@recursyve/ngx-material-components/typeahead";
import { isPropertyDefined } from "@recursyve/nice-ts-utils";
import type { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { ApiService } from "../../../../api/local-144/api.service";
import { findAllEmploymentSkills } from "../../../../api/local-144/fn/employment-skills/find-all-employment-skills";
import { getEmploymentSkillById } from "../../../../api/local-144/fn/employment-skills/get-employment-skill-by-id";
import type { EmploymentSkills } from "../../../../api/local-144/models/employment-skills";

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface EmploymentSkillsTypeaheadSearchOptions {}

export class EmploymentSkillsTypeaheadResource extends NiceAsyncTypeaheadResourceProvider<
    EmploymentSkills,
    number,
    EmploymentSkillsTypeaheadSearchOptions
> {
    private readonly api = inject(ApiService);

    public override readonly resource = "employment-skills";

    private readonly pageSize = 10;

    public override getById(id: number): Observable<EmploymentSkills> {
        return this.api.invoke(getEmploymentSkillById, { id });
    }

    public override search(
        searchQuery: string,
        page: number
    ): Observable<NiceAsyncTypeaheadSearchResult<EmploymentSkills>> {
        return this.api.invoke(findAllEmploymentSkills, { page, searchQuery, pageSize: this.pageSize }).pipe(
            map((items) => ({
                items,
                nextPage: items.length < this.pageSize ? page + 1 : null
            }))
        );
    }

    public override format(skill: EmploymentSkills): string {
        if (!isPropertyDefined(skill, "label")) {
            return "";
        }

        if (typeof skill.label !== "string") {
            return "";
        }

        return skill.label;
    }
}
